export default "__VITE_ASSET__BUfdl85K__"